import { render } from "./TimesheetPendingActions.vue?vue&type=template&id=5c5b8354&scoped=true"
import script from "./TimesheetPendingActions.vue?vue&type=script&lang=js"
export * from "./TimesheetPendingActions.vue?vue&type=script&lang=js"

import "./TimesheetPendingActions.vue?vue&type=style&index=0&id=5c5b8354&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5b8354"]])

export default __exports__